import React from 'react';
import {
  BreadcrumbGroup
} from '@cloudscape-design/components';


export default () => {
    return (
        <BreadcrumbGroup
            items={[
                { text: "Amazon Neptune", href: "https://aws.amazon.com/neptune/", external: true},
                { text: "Demos", href: "https://www.neptunedemos.com/"},
                { text: "Healthcare Life Sciences (PubMed VSS)", href: "/" }
            ]}
            ariaLabel='Breadcrumbs'
        ></BreadcrumbGroup>
    )
}